// User administration route (/admin/users, Admin): tab, user search, status and role filters, the invitation status filter and the security-log type and email filters in the URL; the screen is AdminUsersPage.
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

import { zAuthEventType, zInvitationStatus, zRole, zUserStatus } from "@/api/__generated__/zod.gen";
import { enumWithDefault, optionalString } from "@/app/search";
import { AdminUsersPage } from "@/features/admin/AdminUsersPage";

const searchSchema = z.object({
  tab: enumWithDefault(["users", "invitations", "security"], "users"),
  q: optionalString(),
  status: zUserStatus.optional().catch(undefined),
  role: zRole.optional().catch(undefined),
  invitations: zInvitationStatus.optional().catch(undefined),
  event: zAuthEventType.optional().catch(undefined),
  email: optionalString(),
});

const searchDefaults = { tab: "users" } satisfies Partial<z.output<typeof searchSchema>>;

export const Route = createFileRoute("/_app/admin/users")({
  validateSearch: searchSchema,
  search: { middlewares: [stripSearchParams(searchDefaults)] },
  staticData: { crumb: "Users" },
  component: AdminUsersPage,
});
